module.exports = __webpack_public_path__ + "gifts.svg?0e6eb445cc55069ccdc949b0c24b6a94";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gifts.svg
// module id = 123
// module chunks = 0